import React, {useEffect, useState} from 'react';
import './Stepper.less';
import {App, Button, Flex} from "antd";
import {MdDone} from "react-icons/md";
import Typography from "antd/lib/typography";
import {resultStore} from "../../../../store/admissions/admissionStore";
import {postRequest} from "../../../../api/httpRequest";
import {stepsStore} from "../../../../store/admissions/stepperStore";
import {LuMinus} from "react-icons/lu";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";
import {filesStore} from "../../../../store/store";

interface IStep {
    title: string,
    content: React.ReactNode
}

interface StepperProps {
    steps: IStep[];
}

const Stepper: React.FC<StepperProps> = ({steps}) => {

    const {stepsData, setStepsData} = stepsStore();
    const {result, setResult} = resultStore();
    const [isRequested, setIsRequested] = useState(false);
    const {xl} = useBreakpoint()
    const {files, setFiles} = filesStore();
    const {notification} = App.useApp();

    useEffect(() => {

    }, [stepsData.currentStep]);

    return (
        <Flex style={{width: '100%', height: '100%', flexDirection: !xl ? 'column-reverse' : "row"}} gap={16}
              vertical={!xl}>
            <Flex className="stepper-content" gap={16} justify="space-around" align="center" vertical={true}>
                {steps[stepsData.currentStep].content}
                <Flex gap={16}>
                    {stepsData.currentStep > 0 && stepsData.currentStep < steps.length - 1 &&
                        <Button onClick={() => {
                            setStepsData({
                                ...stepsData,
                                currentStep: stepsData.currentStep - (stepsData.backStep + 1),
                                forwardStep: stepsData.backStep,
                                backStep: 0
                            })
                        }}>
                            Назад
                        </Button>}
                    {stepsData.currentStep < steps.length - 2 &&
                        <Button disabled={!stepsData.nextStep} type={"primary"} onClick={() => {
                            if (stepsData.currentStep === 2) {
                                if (result.citizenship !== "643") {
                                    if (files["Документ, удостоверяющий личность"] === undefined) {
                                        notification.error({
                                            message: "Загрузите все документы",
                                            description: "необходимо загрузить Документ, удостоверяющий личность"
                                        })
                                        return
                                    }
                                    if (files["Место жительства"] === undefined) {
                                        notification.error({
                                            message: "Загрузите все документы",
                                            description: "необходимо загрузить Место жительства"
                                        })
                                        return
                                    }
                                }
                                if (result.citizenship === "643" && files["Главный разворот паспорта"] === undefined) {
                                    notification.error({
                                        message: "Загрузите все документы",
                                        description: "необходимо загрузить главный разворот паспорта"
                                    })
                                    return
                                }
                            }
                            if (stepsData.currentStep === 3) {
                                if (result.citizenship !== "643") {
                                    if (files["Документ об образовании"] === undefined) {
                                        notification.error({
                                            message: "Загрузите все документы",
                                            description: "необходимо загрузить Документ об образовании"
                                        })
                                        return
                                    }
                                    if (files["Приложение к документу об образовании"] === undefined) {
                                        notification.error({
                                            message: "Загрузите все документы",
                                            description: "необходимо загрузить Приложение к документу об образовании"
                                        })
                                        return
                                    }
                                }
                                if (result.citizenship === "643" && files["Лицевой разворот диплома/аттестата"] === undefined) {
                                    notification.error({
                                        message: "Загрузите все документы",
                                        description: "необходимо загрузить лицевой разворот диплома/аттестата"
                                    })
                                    return
                                }
                            }

                            setStepsData({
                                currentStep: stepsData.forwardStep !== 0 ? stepsData.currentStep + (stepsData.forwardStep + 1) : stepsData.currentStep + 1,
                                completedSteps: [...stepsData.completedSteps, stepsData.currentStep],
                                skippedSteps: stepsData.skippedSteps,
                                nextStep: false,
                                backStep: stepsData.forwardStep,
                                forwardStep: 0
                            })
                        }}>
                            Продолжить
                        </Button>}
                    {stepsData.currentStep === steps.length - 2 &&
                        <Button disabled={!stepsData.nextStep} loading={isRequested} type={"primary"} onClick={() => {
                            setIsRequested(true)
                            const sortedPriority = result.concourseGroupsPriority?.sort((a, b) => a.priority - b.priority);
                            sortedPriority.forEach((item) => {
                                item.profiles = item.profiles.sort((a, b) => a.priority - b.priority);
                            })
                            const request = {
                                kindsLevelFormationCode: result.kindsLevelFormation,
                                needador: result.needador,
                                kindsTrainingCode: result.kindsTrainingCode,
                                competition: result.competition,
                                concourseGroups: sortedPriority,
                                offernumber: result.offernumber,
                                offernumberposted: result.offernumberposted,
                                surname: result.surname,
                                name: result.name,
                                patronymic: result.patronymic,
                                snils: result.snils,
                                gender: result.gender,
                                birthdate: result.birthdate,
                                telephone: `${result.telephone}`,
                                email: result.email,
                                citizenship: result.citizenship,
                                education: result.education,
                                categories: result.categories === null ? [] : result.categories,
                                achievements: result.achievements,
                                Iampayer: result.Iampayer,
                                notcontract: result.notcontract,
                                otherpayer: result.otherpayer,
                                EG: result.EG,
                                Bookentryexams: result.Bookentryexams,
                                consent: result.consent,
                                exams: result.exams,
                            }
                            postRequest("/server/proxy/contracts/regStudApp", request)
                                .then(response => {
                                    setStepsData({
                                        currentStep: stepsData.currentStep + 1,
                                        completedSteps: [...stepsData.completedSteps, stepsData.currentStep],
                                        skippedSteps: stepsData.skippedSteps,
                                        nextStep: false,
                                        backStep: 0,
                                        forwardStep: 0
                                    })
                                    setIsRequested(false)
                                })
                                .catch(error => {
                                    setIsRequested(false)
                                })
                        }}>
                            Отправить заявление
                        </Button>
                    }
                </Flex>
            </Flex>
            {xl ?
                <Flex className="stepper-steps" justify="space-around" align="flex-start" vertical={true}>
                    <Flex style={{width: "100%", padding: "16px"}} justify="center" align="center" vertical={true}>
                        <Typography.Text style={{fontSize: "18px"}}>Шаги заполнения заявления</Typography.Text>
                    </Flex>
                    <Flex vertical={true}
                          style={{width: "100%", padding: "0 16px 16px 16px", height: "100%"}}
                          justify="space-between"
                    >
                        {steps.map((step, index) => (
                            <Flex align={"center"} gap={16} key={index}>
                                <Flex vertical={true} align={"center"} gap={4}>
                                    <Flex
                                        className={`step ${stepsData.skippedSteps.includes(index) ? 'skipped' : ''} ${stepsData.completedSteps.includes(index) ? 'completed' : ''} ${index === stepsData.currentStep ? 'active' : ''}`}
                                        justify="center" align="center" key={index}
                                    >
                                        {stepsData.completedSteps.includes(index) ?
                                            <MdDone/> :
                                            <Flex>{stepsData.skippedSteps.includes(index) ?
                                                <LuMinus/> : index + 1}</Flex>}
                                    </Flex>
                                    {index !== steps.length - 1 && <div
                                        className={`step-line ${(stepsData.completedSteps.includes(index) || stepsData.skippedSteps.includes(index)) && index !== stepsData.currentStep - 1 ? 'completed' : ''} ${index === stepsData.currentStep - 1 ? 'active' : ''}`}></div>}
                                </Flex>
                                <Flex style={{height: "100%"}} vertical={true} align={"flex-start"}
                                      justify={"flex-start"}>
                                    <Typography.Text
                                        className={`step-title ${index === stepsData.currentStep ? 'active' : ''}`}>{step.title}</Typography.Text>
                                </Flex>
                            </Flex>
                        ))}
                    </Flex>
                </Flex>
                :
                <Flex>
                </Flex>}
        </Flex>
    )

};

export default Stepper;

